import * as React from "react";
import {Controller, useFormContext} from "react-hook-form";
import {Alert, TextFieldProps} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {DateTimePicker} from '@mui/x-date-pickers';
import dayjs from "dayjs";

export type FormInputDateTimeProps = Omit<TextFieldProps, 'name'> & {
   name: string;
   label: string;
   errorMessage?: string;
   ampm?: boolean;
}

export const FormInputDateTime = ({
                                     name,
                                     label,
                                     errorMessage,
                                     ampm = false,
                                     ...rest
                                  }: FormInputDateTimeProps) => {
   const classes = useStyles();

   const methods = useFormContext();
   const { formState: { errors }, control } = methods;
   const showError = !!errors[name];

   return (
      <div className={classes.noBorderRadius}>
         <Controller
            name={name}
            control={control}
            defaultValue={null}
            render={({
                        field: { onChange, value },
                        fieldState: { invalid }
                     }) => (
               <DateTimePicker
                  label={label}
                  value={value ? new Date(value) : null}
                  ampm={ampm}
                  minutesStep={5}
                  format={"dd/MM/yyyy HH:mm"}
                  onChange={(newValue) => {
                     if (!newValue) {
                        onChange(null);
                     } else {
                        onChange(dayjs(newValue).format("YYYY-MM-DD HH:mm:ss"))
                     }
                  }}
                  slotProps={{
                     textField: {
                        id: name,
                        size: "small",
                        variant: "filled",
                        margin: "none",
                        fullWidth: true,
                        error: invalid,
                        helperText: invalid ? errorMessage : null,
                        InputLabelProps: {shrink: true},
                        InputProps: {
                           disableUnderline: true,
                           style: {backgroundColor: 'transparent'}
                        },
                        style: {
                           border: showError ? '1px solid #f00000' : '1px solid #d0d0d0',
                           marginBottom: '8px'
                        }
                     }
                  }}
               />
            )}
         />
         {showError && <Alert variant="filled" severity="error">{errors[name]?.message}</Alert>}
      </div>
   );
};

const useStyles = makeStyles({
   noBorderRadius: {
      "& fieldset": {
         borderRadius: 0,
      },
      width: '100%'
   }
});